import config from '../../package.json';
import { hostPath, payApi2 } from '@utils/basePath';
import { getWechatSignature, getAliPaySign, getWechatSign, getAppPaySign } from '@/api/pay';
import { Toast, Dialog } from 'vant';
// import CallApp from 'callapp-lib';
const docCookie = require('@utils/cookies');
let ua = navigator.userAgent;
// h5 app 交互
export const jumpModuleApp = (data) => {
    /**
     * @params
     * typeId
     * operation_detail 训练营详情
     * mall_detail  商城详情
     * open_detail  公开课详情
     * vip_member_open  开通会员
     * article_detail  文章详情
     * pbl_discuss_create pbl话题创建
     * image_preview
     * live_stream_detail 直播
     * app_store 进入 ios app store；
     *
     * dataId
     * albumId liveId exerciseId meetingId 等，根据 typeId 类型对应添加
     *
     * orderId
     * 订单ID
     * url 新的 webview 的 h5 链接
     * type
     *  webview h5 链接中的 query 的 type 值
     * images
     * 图片预览
     * posIndex
     * 图片位置
     */
    if (!appPort()) {
        return;
    }
    if (!data.dataId) {
        data.dataId = '0';
    }
    if (androidPort()) {
        window.JavaScriptInterface.jumpModule(JSON.stringify(data));
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.jumpModule.postMessage(data);
    }
};
// ios app store
export const goAppStore = () => {
    if (iOSPort()) {
        jumpModuleApp({ typeId: 'app_store' });
    }
};
// iOS 端判断
export const iOSPort = () => {
    return !!ua && /iPhone|iPad|iPod/gi.test(ua);
};
// android 判断
export const androidPort = () => {
    return /(Android|Linux)/gi.test(ua);
};
// app 端判断
export const appPort = () => {
    const isApp = !wechatPort() &&
        (window.JavaScriptInterface ||
            (window.webkit && window.webkit.messageHandlers.jumpModule));
    return !!isApp;
};
// 微信端判断
export const wechatPort = () => {
    return /MicroMessenger/gi.test(ua);
};
// PC端判断
export const PCPort = () => {
    return !/(Android|iPhone|SymbianOS|Windows Phone|iPad|iPod|Mobile|HarmonyOS)/gi.test(ua);
};
// 回到首页
export const backHome = () => {
    if (androidPort()) {
        window.JavaScriptInterface.goMainHome();
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.mineTeachetBackHome.postMessage('');
    }
};
// 返回上一页
export const prevPageView = (backFn) => {
    if (appPort()) {
        mobileApi({ type: 'webViewBack' });
    }
    else {
        if (backFn) {
            backFn();
        }
        else {
            history.go(-1);
        }
    }
};
// 获取用户ID
export const getUserId = () => {
    const id = Number(localStorage.getItem('USER_ID'));
    const USER_ID = isNaN(id) ? 0 : id;
    if (appPort()) {
        if (androidPort()) {
            const aUserId = window.JavaScriptInterface.getUserId();
            return aUserId ? Number(aUserId) : 0;
        }
        else if (iOSPort()) {
            const iUserId = navigator.userAgent
                .match(/\$\$userId=\d+\$\$/g)
                ?.join('')
                .replace(/[a-zA-Z$=]/g, '');
            return iUserId ? Number(iUserId) : 0;
        }
        else {
            return USER_ID;
        }
    }
    else {
        const COOKIE_USER_ID = docCookie.getItem('USER_ID');
        if (COOKIE_USER_ID) {
            return Number(COOKIE_USER_ID) || 0;
        }
        else {
            return Number(USER_ID) || 0;
        }
    }
};
export const getTokenObj = () => {
    if (!appPort()) {
        return {
            token: docCookie.getItem('token') || '',
            version: config.version,
            userId: getUserId()
        };
    }
    if (androidPort()) {
        if (window.JavaScriptInterface.getAuthorizationToken) {
            let jsonStr = window.JavaScriptInterface.getAuthorizationToken();
            return jsonStr && JSON.parse(jsonStr);
        }
        else {
            return {
                token: '',
                version: config.version,
                userId: 0
            };
        }
    }
    else if (iOSPort()) {
        let agent = navigator.userAgent;
        if (agent.split('####')) {
            return JSON.parse(agent.split('####')[1].replace('tokenStr=', ''));
        }
        else {
            return {
                token: '',
                version: config.version,
                userId: 0
            };
        }
    }
    else {
        return {
            token: '',
            version: config.version,
            userId: 0
        };
    }
};
/**
 * 用户登录
 * @params
 * url 登录成功后后返回地址
 * anth 是否需要微信认证
 * query 对象类型 传到登录页面的地址参数
 * */
export const userLogin = (params) => {
    let url = params?.url || '';
    let auth = params?.auth || false;
    let query = params?.query || null;
    if (!appPort()) {
        const tokenObj = getTokenObj();
        const login = tokenObj.userId || tokenObj.token; // 登录状态
        const openId = localStorage.getItem('openId');
        const backUrl = window.encodeURIComponent(url || location.pathname + location.search);
        const wechatAuth = wechatPort();
        const userLoginAuthFn = (type) => {
            if (query) {
                location.href = `${hostPath}/user/${type}?${queryToString(query)}`;
            }
            else {
                location.href = `${hostPath}/user/${type}?backUrl=${backUrl}`;
            }
        };
        if (auth) {
            if (wechatAuth) {
                if (!login || !openId) {
                    userLoginAuthFn('auth');
                }
            }
            else {
                docCookie.removeItem('token');
                docCookie.removeItem('USER_ID');
                userLoginAuthFn('login');
            }
        }
        else {
            if (login) {
                // 删除登录信息重新登录
                docCookie.removeItem('token');
                docCookie.removeItem('USER_ID');
            }
            userLoginAuthFn('login');
        }
    }
    else {
        // 手机端登录
        jumpModuleApp({
            typeId: 'userLogin'
        });
    }
};
// 时间戳转换
export const formatDate = (type, time) => {
    let t = new Date(time);
    let y = t.getFullYear();
    let mm = t.getMonth() + 1;
    let dd = t.getDate();
    let h = t.getHours();
    let m = t.getMinutes();
    let s = t.getSeconds();
    if (type.toUpperCase() === 'YYYY-MM-DD') {
        return y + '-' + adjust(mm) + '-' + adjust(dd);
    }
    else {
        return (y +
            '-' +
            adjust(mm) +
            '-' +
            adjust(dd) +
            ' ' +
            adjust(h) +
            ':' +
            adjust(m) +
            ':' +
            adjust(s));
    }
    function adjust(n) {
        return n > 9 ? n + '' : '0' + n;
    }
};
// APP 内拨打电话
export const callPhone = (tel) => {
    // 拨打电话
    if (appPort()) {
        if (androidPort()) {
            window.JavaScriptInterface.tellPhone(String(tel));
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.CallCustomerService.postMessage(tel);
        }
    }
    else {
        window.open(`tel:${tel}`);
    }
};
// 调用手机端api
export const mobileApi = (data) => {
    if (androidPort()) {
        window.JavaScriptInterface.mobileApi(JSON.stringify(data));
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.mobileApi.postMessage(data);
    }
};
// 日历分享图片
export const calendarDetailAlert = (data) => {
    if (appPort()) {
        let d = JSON.stringify(data);
        if (androidPort()) {
            window.JavaScriptInterface.calendarDetailAlert(d);
            console.log(1);
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.calendarDetailAlert.postMessage(d);
            console.log(2);
        }
    }
};
export const appShare = (data, type = 'share') => {
    mobileApi({ type, data: { ...data } });
};
// 隐藏app webview 全屏
export const appFullScreen = function () {
    if (androidPort()) {
        window.JavaScriptInterface.fullScreen();
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.fullScreen.postMessage('');
    }
};
// 打开微信小程序页面
export const openWXPage = function (url) {
    if (androidPort()) {
        window.JavaScriptInterface.jumpToMiniAppCustomer(url);
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.jumpToMiniAppCustomer.postMessage(url);
    }
};
// 微信分享
export const weixinShare = (shareData, callback) => {
    if (!wechatPort()) {
        return;
    }
    new Promise(resolve => {
        getWechatSignature({
            url: location.href
        }).then(res => {
            const { appId, timestamp, nonceStr, signature } = res.data;
            globalThis.wx.config({
                debug: false,
                appId,
                timestamp,
                nonceStr,
                signature,
                jsApiList: [
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'onMenuShareWeibo'
                ],
                openTagList: ['wx-open-launch-app']
            });
            resolve(null);
        });
    }).then(() => {
        globalThis.wx.ready(() => {
            globalThis.wx.updateAppMessageShareData({
                title: shareData.title,
                desc: shareData.desc,
                link: shareData.url,
                imgUrl: shareData.image,
                complete() {
                    callback && callback();
                },
                fail() {
                    // console.log('接口调用失败')
                }
            });
            globalThis.wx.updateTimelineShareData({
                title: shareData.title,
                link: shareData.url,
                imgUrl: shareData.image,
                complete() {
                    callback && callback();
                },
                fail() {
                    // console.log('接口调用失败')
                }
            });
            globalThis.wx.onMenuShareWeibo({
                title: shareData.title,
                desc: shareData.desc,
                link: shareData.url,
                imgUrl: shareData.image,
                complete() {
                    callback && callback();
                }
            });
        });
        globalThis.wx.error(err => {
            if (!iOSPort) {
                Toast(err.errMsg);
            }
        });
    });
    // success：接口调用成功时执行的回调函数。
    // fail：接口调用失败时执行的回调函数。
    // complete：接口调用完成时执行的回调函数，无论成功或失败都会执行。
    // cancel：用户点击取消时的回调函数，仅部分有用户取消操作的api才会用到。
    // trigger: 监听Menu中的按钮点击时触发的方法，该方法仅支持Menu中的相关接口
};
// 隐藏app webview navbar
export const hiddenAppNavBar = () => {
    if (versionCompare('6.0.1') && appPort()) {
        // 隐藏app webview navbar
        if (androidPort()) {
            window.JavaScriptInterface.hiddenNavidationBar &&
                window.JavaScriptInterface.hiddenNavidationBar();
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.hiddenNavidationBar.postMessage('');
        }
    }
};
// 将对象 query 转成 string
export const queryToString = query => {
    let str = '';
    Object.keys(query).map(key => {
        str += key + '=' + query[key] + '&';
    });
    return str.slice(0, str.length - 1);
};
// 获取cookie
export const getCookie = function (sKey) {
    return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
        encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
        '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
};
// 设置cookie
export const setCookie = function (sKey, sValue, vEnd, sPath = '/', sDomain, bSecure) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
        return false;
    }
    if (!sDomain) {
        let hostname = location.hostname;
        if (/haoyishu.org$/.test(hostname)) {
            sDomain = 'haoyishu.org';
        }
        else if (/haoyishu.com$/.test(hostname)) {
            sDomain = 'haoyishu.com';
        }
        else if (/zven.cn$/.test(hostname)) {
            sDomain = 'vzen.cn';
        }
        else {
            sDomain = hostname;
        }
    }
    let sExpires = '';
    if (vEnd) {
        switch (vEnd.constructor) {
            case Number:
                sExpires =
                    vEnd === Infinity
                        ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                        : '; max-age=' + vEnd;
                break;
            case String:
                sExpires = '; expires=' + vEnd;
                break;
            case Date:
                sExpires = '; expires=' + vEnd.toUTCString();
                break;
        }
    }
    document.cookie =
        encodeURIComponent(sKey) +
            '=' +
            encodeURIComponent(sValue) +
            sExpires +
            (sDomain ? '; domain=' + sDomain : '') +
            (sPath ? '; path=' + sPath : '') +
            (bSecure ? '; secure' : '');
    return true;
};
// 删除cookie
export const removeCookie = (sKey, sPath = '/', sDomain) => {
    if (!sKey) {
        return false;
    }
    // sKey = getKey(sKey)
    if (!sDomain) {
        let hostname = location.hostname;
        if (/haoyishu.org$/.test(hostname)) {
            sDomain = 'haoyishu.org';
        }
        else if (/haoyishu.com$/.test(hostname)) {
            sDomain = 'haoyishu.com';
        }
        else if (/vzen.cn$/.test(hostname)) {
            sDomain = 'vzen.cn';
        }
        else {
            sDomain = hostname;
        }
    }
    document.cookie =
        encodeURIComponent(sKey) +
            '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
            (sDomain ? '; domain=' + sDomain : '') +
            (sPath ? '; path=' + sPath : '');
    return true;
};
// 设置gio
export const setGio = ({ type, key, data }) => {
    type = type || 'track';
    if (window.gio) {
        if (key && data) {
            gio(type, key, {
                platform: portInfo(),
                ...data
            });
        }
        else {
            gio(type);
        }
    }
};
// 当前终端
const portInfo = () => {
    if (appPort()) {
        if (iOSPort()) {
            return 'iOS';
        }
        else if (androidPort()) {
            return '安卓';
        }
    }
    else if (PCPort()) {
        return '官网';
    }
    else {
        return 'H5';
    }
};
/**
 * @param video 视频地址或视频地址对象
 * url
 */
export const playVideoFullScreen = (video) => {
    if (versionCompare('6.4.1') && video.url) {
        // 可以切换清晰度
        if (androidPort()) {
            window.JavaScriptInterface.bojuVideoPathChanged(JSON.stringify({ ...video }));
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.bojuVideoPathChanged.postMessage({
                ...video
            });
        }
    }
    else {
        let data = (typeof video).toLowerCase() === 'string' ? video : video.url;
        if (androidPort()) {
            window.JavaScriptInterface.bojuVideo(JSON.stringify({ video: data }));
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.bojuVideo.postMessage({ video: data });
        }
    }
};
// iOS 支付 病例练习支付
export const applePay = (data) => {
    if (iOSPort() && appPort()) {
        if (versionCompare('6.4.1')) {
            window.webkit.messageHandlers.applePay.postMessage(data);
        }
        else {
            Dialog.confirm({
                message: '请更新App再支付',
                confirmButtonText: '去更新'
            })
                .then(() => {
                goAppStore();
            })
                .catch(() => {
                // console.log(1212)
            });
        }
    }
};
// 共学营苹果支付
export const applePayOnline = (data) => {
    if (iOSPort() && appPort()) {
        if (versionCompare('8.0.0')) {
            window.webkit.messageHandlers.applePay.postMessage(data);
        }
        else {
            Dialog.confirm({
                message: '请更新App再支付',
                confirmButtonText: '去更新'
            })
                .then(() => {
                goAppStore();
            })
                .catch(() => {
                // console.log(1212)
            });
        }
    }
};
// app 查看大图
export const imagePreview = ({ typeId, images, posIndex }) => {
    let imgs = JSON.parse(JSON.stringify(images));
    const data = {
        typeId,
        images: imgs,
        posIndex
    };
    jumpModuleApp(data);
};
// 关闭webview
export const closeWebView = () => {
    if (androidPort()) {
        window.JavaScriptInterface.exchangeSuccess();
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.exchangeSuccess.postMessage('');
    }
};
export const closeLiveCartList = () => {
    if (androidPort()) {
        window.JavaScriptInterface.closeLiveCartList();
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.closeLiveCartList.postMessage('');
    }
};
// 是否登录
export const isLogin = !!getTokenObj().token;
export const callAppView = (obj) => {
    if (!appPort()) {
        if (PCPort()) {
            Toast('请在手机浏览器中打开');
            return;
        }
        let str = window.encodeURIComponent(JSON.stringify(obj));
        if (iOSPort()) {
            location.href = `https://www.haoyishu.com/hysapp?params=${str}`;
        }
        else if (androidPort()) {
            window.open(`haoyishu://www.haoyishu.org/hysapp?params=${str}`);
            let timeOut = setTimeout(() => {
                if (document.visibilityState === 'visible') {
                    location.href =
                        'https://a.app.qq.com/o/simple.jsp?pkgname=com.example.haoyishu';
                }
                else {
                    clearTimeout(timeOut);
                }
            }, 1500);
        }
    }
};
/**
 * @export
 * @param {String} compareVersion 比较版本
 * @returns {Boolean} true -> App 当前版本大于等于比较版本 false -> 小于比较版本
 */
export const versionCompare = (compareVersion) => {
    let currentV = getTokenObj().version;
    let bl = true;
    let current = currentV.split('.');
    let compare = compareVersion.split('.');
    let maxL = Math.max(current.length, compare.length);
    for (let i = 0; i < maxL; i++) {
        let currentVal = Number(current[i]) || 0;
        let compareVal = Number(compare[i]) || 0;
        if (currentVal < compareVal) {
            bl = false;
            break;
        }
        else if (currentVal > compareVal) {
            bl = true;
            break;
        }
    }
    return bl;
};
// 获取元素宽度，返回 rem 宽度值
// p 元素 padding 值（单位 px）
export const getDomWidth = (dom, p, m) => {
    let rem = Number(localStorage.getItem('rem') || 100);
    if (!dom) {
        return 0;
    }
    let nodes = dom.children;
    let w = 0;
    for (let i = 0; i < nodes.length; i++) {
        w += nodes[i].offsetWidth;
    }
    if (nodes.length === 0) {
        w = dom.offsetWidth;
    }
    w = Math.ceil((w * 100) / rem);
    if (p) {
        w += p;
    }
    if (m && nodes.length) {
        w = w + (nodes.length - 1) * m;
    }
    return w / 100;
};
// 获取 url 中的参数
export const getUrlParam = (param) => {
    let p = new URLSearchParams(location.search);
    return p.get(param) || '';
};
// app 交互，弹出遮罩
export const appSelectedTypeAlert = (url) => {
    if (appPort()) {
        if (androidPort()) {
            window.JavaScriptInterface.selectedTypeAlert(url);
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.selectedTypeAlert.postMessage(url);
        }
    }
};
export const getClassType = (n) => {
    if (appPort()) {
        if (androidPort()) {
            window.JavaScriptInterface.getClassType(JSON.stringify(n));
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.getClassType.postMessage(JSON.stringify(n));
        }
    }
};
// app学习页判断
export const validateXue = () => {
    if (!appPort()) {
        return false;
    }
    let xue = getUrlParam('xue');
    return !!xue && versionCompare('8.1.0');
};
// 学习页弹框关闭
export const closeAppView = () => {
    if (appPort()) {
        if (androidPort()) {
            window.JavaScriptInterface.closeAlert();
        }
        else if (iOSPort()) {
            window.webkit.messageHandlers.closeAlert.postMessage('');
        }
    }
};
// 去学习 进入app学习页
export const goToStudy = (t, id, m, lessonId, taskId) => {
    if (!appPort()) {
        // TODO 跳转到 app 学习页定位到学习任务
        // location.assign('https://datayi.cn/bLbjaaidWmmO')
        callAppView({
            typeId: 'study_play_detail',
            type: t,
            dataId: id,
            lessonId: lessonId,
            taskId: taskId
        });
        return;
    }
    if (versionCompare('8.1.0')) {
        lessonId = lessonId || 0;
        taskId = taskId || 0;
        jumpModuleApp({
            typeId: 'study_play_detail',
            type: t,
            dataId: id,
            lessonId: lessonId,
            taskId: taskId
        });
        return;
    }
    // if (iOSPort()) {
    //   Toast('请升级APP版本')
    // } else {
    // }
    if (t == 'album') {
        jumpModuleApp({
            typeId: 'open_detail',
            dataId: id
        });
    }
    else if (m) {
        // omo 、尊享大师课
        jumpModuleApp({
            typeId: 'exercise_home',
            dataId: id,
            type: m
        });
    }
};
// 保留小数
export const mathRound = (number, precision) => {
    return Math.round(Number(+number + 'e' + precision)) / Math.pow(10, precision);
    // same as:
    // return Number(Math.round(+number + 'e' + precision) + 'e-' + precision);
};
// 微信支付事件监听
const wechatPayInfo = (jsApiParameters, fn) => {
    const onBridgeReady = () => {
        WeixinJSBridge.invoke('getBrandWCPayRequest', jsApiParameters, res => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
                fn && fn('success');
            }
            else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                fn && fn('cancel');
            }
            else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                Toast('支付失败，请稍后或重新尝试支付！');
                fn && fn('fail');
            }
            else {
                fn && fn(res.err_msg);
            }
        });
    };
    if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            // @ts-ignore
        }
        else if (document.attachEvent) {
            // @ts-ignore
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            // @ts-ignore
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    }
    else {
        onBridgeReady();
    }
};
// 微信认证
export const wechatAuth = () => {
    // 微信 code 校验
    if (wechatPort()) {
        let base = payApi2 + '/wechat/auth?redirectURI=';
        let redirectUrl = window.encodeURIComponent(location.href);
        window.location.replace(base + redirectUrl);
    }
};
// 订单支付 'alipay' | 'wechat' | 'balance' | 'freePay' selectOption 是否选择学币
export const orderPay = (type, params, query, callback) => {
    return new Promise((resolve, reject) => {
        if (appPort()) {
            getAppPaySign({
                platform: type,
                module: params.module,
                type: 'app'
            }, {
                orderId: query.orderId,
                selectOption: query.selectOption || false,
                payOnBehalf: query.payOnBehalf
            }).then(res => {
                if (res.code === 200) {
                    if (/^(wechat|alipay)$/.test(type)) {
                        if (!res.data) {
                            reject(res.message + '-' + res.code);
                            return;
                        }
                        resolve(true);
                        // 调用app微信支付宝支付
                        let source = { type: type, sign: res.data };
                        if (androidPort()) {
                            window.JavaScriptInterface.bojuPay(JSON.stringify(source));
                        }
                        else if (iOSPort()) {
                            window.webkit.messageHandlers.bojuPay.postMessage(source);
                        }
                    }
                    else {
                        resolve(true);
                        callback && callback();
                    }
                }
                else {
                    reject(res.message + '-' + res.code);
                }
            });
            return;
        }
        if (type == 'alipay') {
            document.querySelector('#aliFormBox')?.remove();
            getAliPaySign({ params, query }).then(res => {
                const data = res;
                if (res.code === 200 && data) {
                    const div = document.createElement('div');
                    div.setAttribute('id', 'aliFormBox');
                    /* 此处form就是后台返回接收到的数据 */
                    div.innerHTML = data.data;
                    document.body.appendChild(div);
                    let l = document.forms.length;
                    document.forms[l - 1].submit();
                    div.remove();
                    resolve(true);
                }
                else {
                    reject(res.message + '-' + res.code);
                }
            });
        }
        else if (type == 'wechat') {
            const openId = localStorage.getItem('openId');
            if (!openId) {
                userLogin({ url: '', auth: true });
                reject('缺少参数openId');
                return;
            }
            getWechatSign({
                params: { module: params.module },
                query: {
                    orderId: query.orderId,
                    openId: openId,
                    selectOption: query.selectOption || false,
                    payOnBehalf: query.payOnBehalf
                }
            }).then(res => {
                if (res.code === 200) {
                    resolve(true);
                    let sign = res.data;
                    window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
                        appId: sign.appId,
                        timeStamp: sign.timeStamp,
                        nonceStr: sign.nonceStr,
                        package: sign.packageValue,
                        signType: sign.signType,
                        paySign: sign.paySign
                    }, res => {
                        if (res.err_msg === 'get_brand_wcpay_request:ok') {
                            // 支付成功
                            callback && callback('ok');
                        }
                        else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                            callback && callback('支付取消');
                        }
                        else {
                            callback && callback(res.err_msg);
                        }
                    });
                }
                else {
                    reject(res.message + '-' + res.code);
                }
            });
        }
        else {
            // 其他类型支付 freePay balance
            getAppPaySign({
                platform: type,
                module: params.module,
                type: 'h5'
            }, {
                orderId: query.orderId,
                selectOption: query.selectOption,
                payOnBehalf: query.payOnBehalf
            }).then(res => {
                if (res.code === 200) {
                    resolve(true);
                    callback && callback();
                }
                else {
                    reject(res.message + '-' + res.code);
                }
            });
        }
    });
};
// 推荐GIO埋点
// https://haoyishu.feishu.cn/sheets/shtcnvvoBjf4b5htQmiZ60xkpaf?sheet=8VHdPu
export const recommendGIO = (data) => {
    return new Promise(resolve => {
        if (window.gio) {
            gio('track', 'click_recommend', {
                platform: platformInfo(),
                ...data
            });
            resolve(true);
        }
        else {
            resolve(true);
        }
    });
};
export const platformInfo = () => {
    if (iOSPort()) {
        return 'iOS';
    }
    else if (androidPort()) {
        return '安卓';
    }
    return 'H5';
};
// rem获取px值
export const getPx = n => {
    let rem = Number(localStorage.getItem('rem'));
    return parseInt((n * 100) / (100 / rem) + '');
};
// 将获取的 px 值 转成 rem
export const pxToRem = (n) => {
    let rem = Number(localStorage.getItem('rem'));
    return mathRound((n * (100 / rem)) / 100, 2);
};
// 获取app bar高度
export const getAppBarHeight = () => {
    let barH = Number(window.barHeight || 0);
    if (!barH) {
        if (androidPort() && appPort() && versionCompare('8.2.0')) {
            barH = window.JavaScriptInterface.getStatusBarHeight();
        }
        else {
            barH = 44;
        }
    }
    return barH;
};
// 修改web背景色
export const setWebBackground = (color) => {
    if (!appPort()) {
        return;
    }
    if (androidPort()) {
        window.JavaScriptInterface.changeWebBackground &&
            window.JavaScriptInterface.changeWebBackground('#' + color);
    }
    else if (iOSPort()) {
        window.webkit.messageHandlers.changeWebBackground &&
            window.webkit.messageHandlers.changeWebBackground.postMessage(color);
    }
};
